<template>
  <div>
    <NavTop/>
    <NavDark/>

    <section class="p-0" aria-label="Kategori genveje">
      <div class="container-fluid p-0">
        <div class="row g-0">
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <router-link
              to="/shop/keramik"
              class="card card-overflow card-scale no-radius mb-0"
              aria-label="Gå til kategorien Keramik"
              title="Keramik"
            >
              <div
                class="bg-image"
                :style="{backgroundImage:`url('${img1}')`, backgroundRepeat:'no-repeat'}"
                data-overlay="2"
                role="img"
                aria-label="Kategori billede Keramik"
              ></div>
              <div class="ct_body">
                <div class="ct_body_caption">
                  <span class="mb-0 ft-bold text-light h2" aria-hidden="true">Keramik</span>
                </div>
                <div class="ct_footer">
                  <span class="btn btn-white stretched-links d-flex align-items-center" role="button" aria-label="Køb keramik">Køb keramik <i class="lni lni-arrow-right" aria-hidden="true"></i></span>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <router-link
              to="/shop/billedkunst"
              class="card card-overflow card-scale no-radius mb-0"
              aria-label="Gå til kategorien Billedkunst"
              title="Billedkunst"
            >
              <div
                class="bg-image"
                :style="{backgroundImage:`url('${img2}')`, backgroundRepeat:'no-repeat'}"
                data-overlay="2"
                role="img"
                aria-label="Kategori billede Billedkunst"
              ></div>
              <div class="ct_body">
                <div class="ct_body_caption">
                  <span class="mb-0 ft-bold text-light h2" aria-hidden="true">Billedkunst</span>
                </div>
                <div class="ct_footer">
                  <span class="btn btn-white stretched-links d-flex align-items-center" role="button" aria-label="Køb billedkunst">Køb billedkunst <i class="lni lni-arrow-right" aria-hidden="true"></i></span>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <router-link
              to="/shop/smykker"
              class="card card-overflow card-scale no-radius mb-0"
              aria-label="Gå til kategorien Smykker"
              title="Smykker"
            >
              <div
                class="bg-image"
                :style="{backgroundImage:`url('${img3}')`, backgroundRepeat:'no-repeat'}"
                data-overlay="2"
                role="img"
                aria-label="Kategori billede Smykker"
              ></div>
              <div class="ct_body">
                <div class="ct_body_caption">
                  <span class="mb-0 ft-bold text-light h2" aria-hidden="true">Smykker</span>
                </div>
                <div class="ct_footer">
                  <span class="btn btn-white stretched-links d-flex align-items-center" role="button" aria-label="Køb smykker">Køb smykker <i class="lni lni-arrow-right" aria-hidden="true"></i></span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

   <!-- <section style="display:grid; grid-template-columns:repeat(auto-fit, minmax(250px,1fr)); gap:20px; padding:0px 20px 0px 20px;">
    <img :src="hero" alt="YOKO - Webshop med unikt kunsthåndværk" style="width:100%; height:auto; display:block;">
</section>

    <section style="display:grid; grid-template-columns:repeat(auto-fit, minmax(250px,1fr)); gap:20px; padding:20px;">
  <a href="/shop/keramik?underkategori=kopper" title="Unikke kopper" style="display:block; overflow:hidden; border-radius:12px; box-shadow:0 4px 10px rgba(0,0,0,0.1); transition:transform 0.3s ease;">
    <img :src="front1" alt="Unikke kopper" style="width:100%; height:auto; display:block;">
  </a>
  <a href="/shop?q=pink" title="Kunsthåndværk i pink" style="display:block; overflow:hidden; border-radius:12px; box-shadow:0 4px 10px rgba(0,0,0,0.1); transition:transform 0.3s ease;">
    <img :src="front2" alt="Kunsthåndværk i pink" style="width:100%; height:auto; display:block;">
  </a>
  <a href="/shop?q=halloween" title="Kreative Halloween" style="display:block; overflow:hidden; border-radius:12px; box-shadow:0 4px 10px rgba(0,0,0,0.1); transition:transform 0.3s ease;">
    <img :src="front3" alt="Kreative Halloween" style="width:100%; height:auto; display:block;">
  </a>
</section>

<section style="display:grid; grid-template-columns:repeat(auto-fit, minmax(250px,1fr)); gap:20px; padding:20px;">

  <a href="/shop/billedkunst?q=tuft" title="Tuftning til indretning" style="display:block; overflow:hidden; border-radius:12px; box-shadow:0 4px 10px rgba(0,0,0,0.1); transition:transform 0.3s ease;">
    <img :src="front5" alt="Tuftning til indretning" style="width:100%; height:auto; display:block;">
  </a>
  <a href="/shop?q=sort/hvid" title="Sort hvid kunsthåndværk" style="display:block; overflow:hidden; border-radius:12px; box-shadow:0 4px 10px rgba(0,0,0,0.1); transition:transform 0.3s ease;">
    <img :src="front4" alt="Sort hvid kunsthåndværk" style="width:100%; height:auto; display:block;">
  </a>
  <a href="/shop?q=hækle" title="Hæklede designs" style="display:block; overflow:hidden; border-radius:12px; box-shadow:0 4px 10px rgba(0,0,0,0.1); transition:transform 0.3s ease;">
    <img :src="front6" alt="Hæklede designs" style="width:100%; height:auto; display:block;">
  </a>
  <a href="/shop/billedkunst?q=øje" title="Kunsthåndværk og billedkunst med øjne" style="display:block; overflow:hidden; border-radius:12px; box-shadow:0 4px 10px rgba(0,0,0,0.1); transition:transform 0.3s ease;">
    <img :src="front7" alt="Kunsthåndværk og billedkunst med øjne" style="width:100%; height:auto; display:block;">
  </a>
</section>-->


    <section class="middle" aria-label="Udvalgte værker">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="sec_title position-relative text-center" data-bgtext="Udvalgte">
              <h2 class="ft-bold pt-3">Udvalgte værker</h2>
            </div>
          </div>
        </div>
        <TrandingProductOne/>
      </div>
    </section>

    <section class="space min" aria-label="Udvalgte kunstnere">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="sec_title position-relative text-center">
              <div class="sec_title position-relative text-center" data-bgtext="Udvalgte">
                <h2 class="ft-bold pt-3">Udvalgte kunstnere</h2>
              </div>
            </div>
          </div>
        </div>

        <div class="row" role="list" aria-label="Kunstnerkort">
          <div v-if="isLoading && featuredArtists.length === 0" class="col-12 text-center py-5" aria-live="polite" aria-busy="true">
            <div class="spinner-border text-dark" role="status" style="width:3rem;height:3rem;">
              <span class="visually-hidden">Henter...</span>
            </div>
          </div>

          <div
            v-for="a in featuredArtists"
            :key="a.artistId"
            class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4"
            role="listitem"
            :aria-label="a.artistName || 'Kunstner'"
          >
            <div class="card h-100">
              <div class="position-relative">
                <RouterLink
                  :to="`/kunstner/${a.artistSubdomain}`"
                  class="d-block"
                  :aria-label="'Se profilside for ' + (a.artistName || 'kunstner')"
                  :title="a.artistName || 'Se kunstnerprofil'"
                >
                  <img
                    :src="a.artistImage"
                    class="card-img-top"
                    :alt="a.artistName ? 'Billede af ' + a.artistName : 'Billede af kunstner'"
                    style="aspect-ratio: 1/1; object-fit: cover;"
                    loading="lazy"
                    decoding="async"
                  />
                </RouterLink>
                <img
                  v-if="a.artistLogo"
                  :src="a.artistLogo"
                  class="position-absolute bottom-0 end-0 m-2 bg-light p-1 rounded"
                  :alt="a.artistName ? 'Logo for ' + a.artistName : 'Kunstner logo'"
                  style="max-width: 100px; max-height: 50px; object-fit: contain;"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div class="card-body d-flex flex-column">
                <div>
                  <h3 class="card-title h5">
                    <RouterLink
                      :to="`/kunstner/${a.artistSubdomain}`"
                      class="text-dark"
                      :aria-label="'Se profilside for ' + (a.artistName || 'kunstner')"
                      :title="a.artistName || 'Kunstner'"
                    >
                      {{ a.artistName || 'Kunstner' }}
                    </RouterLink>
                  </h3>
                  <p class="card-subtitle mb-2 text-muted" v-html="a.artistPersonName + ' · ' + a.artistCity"></p>
                </div>
                <div class="flex-grow-1">
                  <p class="card-text fs-sm" v-html="a.artistShortDescription"></p>
                </div>
                <div class="mt-auto pt-3">
                  <div class="d-flex align-items-center gap-2">
                    <RouterLink
                      :to="`/kunstner/${a.artistSubdomain}`"
                      class="btn btn-sm btn-outline-dark w-100"
                      :aria-label="'Se profilside for ' + (a.artistName || 'kunstner')"
                      :title="'Profilside for ' + (a.artistName || 'kunstner')"
                    >
                      Se profilside
                    </RouterLink>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!isLoading && featuredArtists.length === 0" class="col-12 text-center py-5" aria-live="polite">
            <p>Ingen kunstnere fundet.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="gray" aria-label="Mød Vibe">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="sec_title position-relative text-center">
              <div class="sec_title position-relative text-center" data-bgtext="Møde Vibe">
                <h2 class="ft-bold pt-3">Mød Vibe</h2>
              </div>
            </div>
          </div>
        </div>
        <ClientOne/>
      </div>
    </section>

    <section  aria-label="Videoer og introduktion">
      <div class="container">

        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="sec_title position-relative text-center">
              <div class="sec_title position-relative text-center" data-bgtext="Hjerterne">
                <h2 class="ft-bold pt-3">Mød hjerterne bag værkerne</h2>
              
              </div>
            </div>
          </div>
        </div>

        <div class="row" aria-label="Video galleri">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-4">
            <div class="rounded overflow-hidden" style="border:2px solid #26b5b1;">
              <lite-youtube videoid="4G4YhxXiNE8" playlabel="Afspil video" title="Mød Herdis fra Nørrebro Keramik" aria-label="Video 1"></lite-youtube>
            </div>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-4">
            <div class="rounded overflow-hidden" style="border:2px solid #26b5b1;">
              <lite-youtube videoid="G0T6xjFWFVg" playlabel="Afspil video" title="Mød Louise fra Ahrenskou Keramik" aria-label="Video 2"></lite-youtube>
            </div>
          </div>

         <!--<div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-4">
            <div class="rounded overflow-hidden border">
              <lite-youtube videoid="8h9OVrD-StY" playlabel="Afspil video" title="Afspil video 3" aria-label="Video 3"></lite-youtube>
            </div>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-4">
            <div class="rounded overflow-hidden border">
              <lite-youtube videoid="oHIdPxWscnM" playlabel="Afspil video" title="Afspil video 4" aria-label="Video 4"></lite-youtube>
            </div>
          </div>-->
        </div>

        <div class="row justify-content-center pt-3">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="sec_title position-relative text-center">
              <div class="sec_title position-relative text-center" data-bgtext="Velkommen">
                <h2 class="ft-bold pt-3">Velkommen til en verden af passion formidlet i håndfast form</h2>
              </div>
              
              Her finder du et nøje udvalgt univers af håndlavet
              <router-link to="/shop/keramik" title="Keramik" aria-label="Gå til Keramik">keramik</router-link>,
              <router-link to="/shop/smykker" title="Smykker" aria-label="Gå til Smykker">smykker</router-link>,
              <router-link to="/shop/billedkunst" title="Billedkunst" aria-label="Gå til Billedkunst">billedkunst</router-link>,
              <router-link to="/shop/tekstil" title="Tekstiler" aria-label="Gå til Tekstiler">tekstiler</router-link>
              og unikt design skabt af passionerede kunstnere og designere.
              <br /><br />
              På vores markedsplads kan du gå på opdagelse blandt ægte kunsthåndværk, hvor hvert produkt fortæller sin egen historie.<br />Uanset om du leder efter en personlig gave, noget særligt til dit hjem eller et smykke, der skiller sig ud, finder du det her.
                <br/><br/>
                Vi samler de bedste danske og internationale skabere ét sted, så du nemt kan støtte kunstnere, designere og små virksomheder, der brænder for deres håndværk.
            </div>
          </div>
        </div>
      </div>
    </section>

    <FooterTopTwo/>
    <FooterDark/>
    <ScrollToTop/>
  </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { useProductStore } from '@/stores/useProductStore';

    // --- IMPORT THE LITE YOUTUBE PLUGIN ---
    import 'lite-youtube-embed';
    import 'lite-youtube-embed/src/lite-yt-embed.css';
    
    import img1 from '@/assets/img/keramik.avif';
    import img2 from '@/assets/img/billedkunst.avif';
    import img3 from '@/assets/img/smykker.avif';

    //import hero from '@/assets/img/hero_yoko.png';

    //import front1 from '@/assets/img/front_kop.png';
    //import front2 from '@/assets/img/front_pink.png';
    //import front3 from '@/assets/img/front_halloween.png';
    //import front4 from '@/assets/img/front_sort-hvid-kunsthaandvaerk.png';
    //import front5 from '@/assets/img/front_tufte.png';
    //import front6 from '@/assets/img/front_haeklet.png';
    //import front7 from '@/assets/img/front_kigger.png';

    import ClientOne from '@/components/client/client-one.vue';
    import NavDark from '@/components/navbar/nav-dark.vue';
    import TrandingProductOne from '@/components/product/tranding-product-one.vue';
    import FooterTopTwo from '@/components/footer/footer-top-one.vue';
    import FooterDark from '@/components/footer/footer-dark.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
    import NavTop from '@/components/navbar/nav-top.vue';

    const store = useProductStore();
    const isLoading = computed(() => store.isLoading);

    const featuredArtists = computed(() => {
        if (!store.productData || store.productData.length === 0) {
            return [];
        }

        const uniqueArtists = new Map();
        store.productData.forEach(product => {
            if (product.artistId && !uniqueArtists.has(product.artistId)) {
                uniqueArtists.set(product.artistId, {
                    artistId: product.artistId,
                    artistSubdomain: product.artistSubdomain,
                    artistImage: product.artistImage,
                    artistLogo: product.artistLogo,
                    artistName: product.artistName,
                    artistPersonName: product.artistPersonName,
                    artistCity: product.artistCity,
                    artistShortDescription: product.artistShortDescription,
                    artistExternalUrl: product.artistExternalUrl,
                });
            }
        });
        return Array.from(uniqueArtists.values()).slice(0, 3);
    });
</script>